export var platformVersionToString = function (_a) {
    var _b = _a === void 0 ? { major: 0, minor: 0, patch: 0 } : _a, major = _b.major, minor = _b.minor, patch = _b.patch;
    return "".concat(major, ".").concat(minor, ".").concat(patch);
};
export var platformVersionFromString = function (pv) {
    if (pv === void 0) { pv = '0.0.0'; }
    return pv.split('.').reduce(function (acc, v, i) {
        if (v === void 0) { v = '0'; }
        if (i > 2) {
            return acc;
        }
        switch (i) {
            case 0:
                acc.major = parseInt(v, 10);
                break;
            case 1:
                acc.minor = parseInt(v, 10);
                break;
            case 2:
                acc.patch = parseInt(v, 10);
                break;
        }
        return acc;
    }, { major: 0, minor: 0, patch: 0 });
};
export var isMajorMinorEqual = function (a, b) {
    if (a === void 0) { a = { major: 0, minor: 0, patch: 0 }; }
    if (b === void 0) { b = { major: 0, minor: 0, patch: 0 }; }
    return (a === null || a === void 0 ? void 0 : a.major) === (b === null || b === void 0 ? void 0 : b.major) && (a === null || a === void 0 ? void 0 : a.minor) === (b === null || b === void 0 ? void 0 : b.minor);
};
export var isStringMajorMinorEqual = function (a, b) {
    if (a === void 0) { a = '0.0.0'; }
    if (b === void 0) { b = '0.0.0'; }
    var pvA = platformVersionFromString(a);
    var pvB = platformVersionFromString(b);
    return isMajorMinorEqual(pvA, pvB);
};
